import { Box } from '@rbilabs/universal-components';

export const Separator = Box.withConfig({
  height: '1px',
  backgroundColor: Styles.color.grey.four,
});
